export default "__VITE_ASSET__BnQO_bbG__"